package com.parmartechnologies.core.feature.inventory.barCode.model

import com.parmartechnologies.core.extension.BaseDataClass
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.Clock
import kotlin.time.ExperimentalTime
@Serializable
data class BarCode @OptIn(ExperimentalTime::class) constructor(
    @SerialName("barcode_id") var BarcodeId: Long = Clock.System.now().epochSeconds,
    @SerialName("user_id") var UserID: String = "",
    @SerialName("business_id") var BusinessID: String = "",
    @SerialName("store_id") var storeId: String = "",
    @SerialName("product_id") var ProductID: String = "",
    @SerialName("inventory_id") var InventoryID: String = "",
    @SerialName("bar_code") var Barcode: String = "",
    @SerialName("invoice_id") var InvoiceID: String = "",
    @SerialName("is_deleted") var IsDeleted: Int = 0,
): BaseDataClass()